import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { SkeletonRow } from './skeleton-row';
const useStyles = createUseStyles({
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  row: {
    '&+&': {
      marginTop: '1em'
    }
  },
  content: {}
});

const Skeleton = props => {
  const {
    rows,
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const rowOptions = typeof rows === 'number' ? Array(rows).fill({
    width: 100
  }) : rows;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const rowClasses = {
    root: classes.row,
    content: classes.content
  };
  return /*#__PURE__*/React.createElement("ul", Object.assign({
    className: className
  }, rest), rowOptions.map((option, index) => {
    const key = `row-${index}`;
    return /*#__PURE__*/React.createElement(SkeletonRow, Object.assign({
      key: key
    }, option, {
      classes: rowClasses,
      "data-pp-at-target": key
    }));
  }));
};

export default Skeleton;